var map = {
	"./arrow_down.svg": 6530,
	"./arrow_left.svg": 5449,
	"./arrow_right.svg": 164,
	"./burger_menu.svg": 2935,
	"./dashboards.svg": 1035,
	"./delete.svg": 5293,
	"./device_management.svg": 8328,
	"./ellipsis.svg": 5725,
	"./file_management.svg": 8044,
	"./help.svg": 5493,
	"./list_sorting.svg": 6745,
	"./list_style_cards.svg": 7818,
	"./list_style_list.svg": 2053,
	"./message_center.svg": 887,
	"./paperclip.svg": 496,
	"./plus.svg": 1796,
	"./reports.svg": 9629,
	"./send.svg": 9910,
	"./settings.svg": 2979,
	"./share.svg": 3661,
	"./statistics.svg": 85,
	"./sync.svg": 6293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;